<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import moment from 'moment'
import { authComputed } from '@/state/helpers'
export default {
  name: 'stats.index',
  page: {
    title: 'Product Stats',
    meta: [{ name: 'description', settings_content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  computed: {
    ...authComputed,
    tagsFoamBlockSize () {
      var arr = []

      this.blockSizes.forEach(blockSize => {
        this.foamTypes.forEach(foamT => {
          arr = [
            ...arr,
            {
              label:
                this.$t(`attribute.block_size.${blockSize}`) +
                ' - ' +
                this.$t(`attribute.foam_type_short.${foamT}`),
              tags: [`${blockSize}`, `foam_${foamT}`]
            }
          ]
        })
      })

      return arr
    },
    tagsFoamTypes () {
      var arr = []

      this.foamTypes.forEach(foamT => {
        arr = [
          ...arr,
          {
            label: this.$t(`attribute.foam_type_short.${foamT}`),
            tags: [`foam_${foamT}`]
          }
        ]
      })

      return arr
    },
    tagsMillTypes () {
      var arr = []
      this.millTypes.forEach(millT => {
        arr = [
          ...arr,
          {
            label: this.$t(`attribute.mill_type.${millT}`),
            tags: [`${millT}`]
          }
        ]
      })

      return arr
    }
  },
  data () {
    return {
      isLoading: false,
      year: moment().year(),
      items: [
        {
          text: 'Statistics',
          active: true
        }
      ],
      foamTypes: ['f32', 'rg50', 'rg70', 'ld24', 's4044'],
      blockSizes: ['block_size_s', 'block_size_l', 'block_size_xl'],
      millTypes: [
        'mill_seat',
        'mill_mattress',
        'mill_std',
        'mill_seat_back',
        'mill_other'
      ],
      currentMonth: moment().format('MMM'),
      currentYear: moment().format('YYYY'),
      startOfYear: moment().startOf('year').toDate(),
      endOfYear: moment().endOf('year').toDate(),
      startOfMonth: moment().startOf('month').toDate(),
      endOfMonth: moment().endOf('month').toDate(),
      totalMillings: 0
    }
  },
  methods: {
    onRefresh: async () => {
      this.isLoading = true

      this.isLoading = false
    },
    nextYear: () => {
      if (this.year < moment().year())
        this.year = moment(this.year).add(1, 'year')
    },
    prevYear: () => {
      if (this.year > 2016) {
        this.year = moment(this.year).subtract(1, 'year')
      }
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="$t('Product Statistics')" :items="items" />

    <b-card-group columns class="mb-3" v-if="userRole === 'admin'">
      <b-card no-body>
        <b-card-body>
          <div class="float-end">{{ totalMillings }}</div>

          <div class="mb-3">
            <h4 class="mb-1 mt-1">
              {{ currentYear }}
            </h4>
            <p class="text-muted mb-0">{{ $t('Total Millings') }}</p>
          </div>

          <div
            v-for="mt in millTypes"
            :key="`${mt}-year`"
            class="d-flex justify-content-between mb-0"
          >
            <small class="text-small">{{
              $t(`attribute.mill_type.${mt}`)
            }}</small>
            <app-quantity-stat
              :start-date="startOfYear"
              :end-date="endOfYear"
              :tags="[`${mt}`]"
            />
          </div>
        </b-card-body>
      </b-card>

      <b-card>
        <div
          v-for="foam in foamTypes"
          :key="`${foam}-year`"
          class="d-flex justify-content-between"
        >
          <small class="text-small">{{
            $t(`attribute.foam_type_short.${foam}`)
          }}</small>
          <app-quantity-stat
            :start-date="startOfYear"
            :end-date="endOfYear"
            :tags="[`foam_${foam}`]"
          />
        </div>
        <div class="font-size-22 font-weight-bold mt-2">
          {{ currentYear }}
        </div>
        <div class="font-size-xs">Quantities Per Foam Type</div>
      </b-card>
      <b-card>
        <div
          v-for="mt in millTypes"
          :key="`${mt}-month`"
          class="d-flex justify-content-between"
        >
          <small class="text-small">{{
            $t(`attribute.mill_type.${mt}`)
          }}</small>
          <app-quantity-stat
            :start-date="startOfMonth"
            :end-date="endOfMonth"
            :tags="[`${mt}`]"
          />
        </div>
        <div class="font-size-22 font-weight-bold mt-2">
          {{ currentMonth }} {{ currentYear }}
        </div>
        <div class="font-size-xs">Total Millings</div>
      </b-card>
      <b-card>
        <div
          v-for="foam in foamTypes"
          :key="`${foam}-month`"
          class="d-flex justify-content-between"
        >
          <small class="text-small">{{
            $t(`attribute.foam_type_short.${foam}`)
          }}</small>
          <app-quantity-stat
            :start-date="startOfMonth"
            :end-date="endOfMonth"
            :tags="[`foam_${foam}`]"
          />
        </div>
        <div class="font-size-22 font-weight-bold mt-2">
          {{ currentMonth }} {{ currentYear }}
        </div>
        <div class="font-size-xs">Quantities Per Foam Type</div>
      </b-card>
      <b-card v-if="userRole === 'admin'">
        <template v-for="blockSize in blockSizes">
          <div
            v-for="mt in foamTypes"
            :key="`${blockSize} ${mt}-year`"
            class="d-flex justify-content-between"
          >
            <small class="text-small">
              {{ $t(`attribute.block_size.${blockSize}`) }} -
              {{ $t(`attribute.foam_type_short.${mt}`) }}
            </small>
            <app-quantity-stat
              :start-date="startOfYear"
              :end-date="endOfYear"
              :tags="[`${mt}`, `${blockSize}`, 'mill_seat']"
            />
          </div>
        </template>

        <div class="font-size-22 font-weight-bold mt-2">
          {{ currentYear }}
        </div>
        <div class="font-size-xs">Quantity Foam Type / Block Size</div>
      </b-card>
    </b-card-group>

    <b-card>
      <app-chart-stats-qty-modeltype />
    </b-card>

    <b-row class="d-flex">
      <b-col :cols="4" xs="12">
        <b-card class="">
          <app-quantity-donut
            :start-date="startOfYear"
            :end-date="endOfYear"
            :tags="tagsFoamTypes"
            :title="$t('Total Quantity / Foam Type')"
          />
          <div class="font-size-22 font-weight-bold mt-2">
            {{ currentYear }}
          </div>
        </b-card>
      </b-col>
      <b-col :cols="4" xs="12">
        <b-card class="">
          <app-quantity-donut
            :start-date="startOfYear"
            :end-date="endOfYear"
            :tags="tagsMillTypes"
            :title="$t('Total Quantity / Milling Type')"
          />
          <div class="font-size-22 font-weight-bold mt-2">
            {{ currentYear }}
          </div>
        </b-card>
      </b-col>
      <b-col :cols="4" xs="12" v-if="userRole === 'admin'">
        <b-card class="">
          <app-quantity-donut
            :start-date="startOfYear"
            :end-date="endOfYear"
            :tags="tagsFoamBlockSize"
            :title="$t('Total Quantity / Foam Type & Block Size')"
          />
          <div class="font-size-22 font-weight-bold mt-2">
            {{ currentYear }}
          </div>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
